
"use strict"; // jshint ignore:line

export default function ActStack( acts ){

	this.undos = [];
	this.redos = [];

	this.acts = {};

	acts && this.addActs( acts );
}

ActStack.prototype.do = function( key ){
	try {
		if( !this.acts[ key ]) return console.warn( "Invalid arguments :: Action '"+ key +"' not found!" );

		return this.acts[ key ].do.apply( this.acts[ key ], [].slice.call( arguments ).slice( 1 ));
	} catch( err ){
		console.error( err );
		throw err;
	}
}

/*********** ACTS ***********/
ActStack.prototype.addActs = function( acts ){
	for( var key in acts ){
		this.addAct( key, acts[ key ]);
	}
};

ActStack.prototype.addAct = function( key, act, act_func ){

	if( !this.acts[key] ) this.acts[key] = { };

	if( arguments.length == 2 ) {

		if( typeof act != "object" ) throw new Error("Invalid Argument");

		if( !act[ "undo" ]) console.warn( "No 'undo'-act for action key: '"+ key +"'" );
		if( !act[ "redo" ]) console.warn( "No 'redo'-act for action key: '"+ key +"'" );

		for( var label in act ) this.addAct( key, label, act[ label ]);

	} else if( arguments.length == 3 ) {

		if( typeof act_func != "function" ) throw new Error("Invalid Argument :: Action function must be typeof function");

		if( this.acts[key][act] ) console.warn("ActStack", "::", act+" for '"+ key +"' has already declared!", this.acts[key][act], act_func );

		this.acts[key][act] = act_func.bind( this.acts[ key ]);

	} else throw new Error("Invalid Argument");
};

/*********** UNDO ***********/

ActStack.prototype.addUndo = function( act, _act ){

	if (arguments.length == 2) {

		_act.key = act;

		act = _act;
	}

	if (!this.acts[act.key]) console.warn("ActStack", "::", "Added Undo-act with unknown key '"+act.key+"'");

	console.log( "undoStack.addUndo", act.key, act );

	this.undos.push( act );

	this.redos.splice( 0, this.redos.length );

	return act;
};
ActStack.prototype.doUndo = function(){
	if( this.undos.length == 0 ) return console.warn("ActStack", "::", "Ignoring doUndo, no more undos");

	var act = this.undos.splice(-1)[0];

	console.info( "ActStack", "::", "Running doUndo()", act.key, act );

	try {
		if (this.acts[act.key]) {
			this.acts[act.key]["$prevCallback"] && this.acts[act.key]["$prevCallback"]( act );
			this.acts[act.key].undo && this.acts[act.key].undo( act );
			this.acts[act.key]["$postCallback"] && this.acts[act.key]["$postCallback"]( act );
		}

		this.redos.push( act );

		try { window.$rootScope.$digest(); } catch (e) {}

	} catch (error) {
		console.error("ActStack", "::", "Failed to undo", error);
	}

	return this.undos.length;
};

/*********** REDO ***********/


ActStack.prototype.addRedo = function( act, _act ){

	if( arguments.length == 2 ) return this.addRedo( (_act.key = act, _act) );

	if( !this.acts[act.key] ) console.warn("ActStack", "::", "Added Undo-act with unknown key '"+act.key+"'");

	this.redos.push( act );

	return act;
};
ActStack.prototype.doRedo = function(){
	if( this.redos.length == 0 ) return console.warn("ActStack", "::", "Ignoring doRedo, no more redos");

	var act = this.redos.splice(-1)[0];

	console.info( "ActStack", "::", "Running reUndo()", act.key, act );

	try {
		if (this.acts[act.key]) {
			this.acts[act.key]["$prevCallback"] && this.acts[act.key]["$prevCallback"]( act );
			this.acts[act.key].redo && this.acts[act.key].redo( act );
			this.acts[act.key]["$postCallback"] && this.acts[act.key]["$postCallback"]( act );
		}

		this.undos.push( act );
		
		try { window.$rootScope.$digest(); } catch (e) {}

	} catch( error ) {
		console.error("ActStack", "::", "Failed to redo", error);
	}

	return this.redos.length;
};
